import {
  IReturnStyleConfig,
  IReturnTextConfig,
} from "@/api/returnpage/type/returnPageConfig"

const style: IReturnStyleConfig = {
  background_image: "",
  portal_top_content: {
    type: "text",
    value: "Return Center",
    url: "",
  },
  login_pop_up: {
    corner_radius: 0,
    opacity: 100,
  },
  font_family: {
    font: "System default font",
    isDefault: true,
    link: "",
  },
  portal_top_logo_width: 0,
  return_page_primary_color: "#303030",
  primary_btn_text_color: "#FFFFFF",
  ex_product_page: {
    logo: "",
    title: "",
  },
}

const text: IReturnTextConfig = {
  email_address: "Email address",
  verification_code: "Verification code",
  bottom_description:
    "You have a maximum of 30 days from the date of your purchase to make a return.",
  return_policy_link: {
    type: "default",
    value: "",
    content: "<P></P>", // 富文本编辑器内容？？
  },
  confirm_button_name: "Start Your Return",
  email_address_error_tips: "Please enter a valid email address",
  verification_code_error_tips: "Please enter a valid verification code",
  email_or_phone_error_tips:
    "Please enter a valid order number and phone number",
  order_email_address: "Email address",
  order_order_number: "Order Number",
  order_bottom_description:
    "You have a maximum of 30 days from the date of your purchase to make a return.",
  order_confirm_button_name: "Start Your Return",
  order_number_error_tips: "Please enter a valid order number",
  order_lookup_method: 1,
  return_policy_link_text_name: "View the full return policy",
  hide_merchant_contact_information: 0, // 0隐藏 1显示
}

export default { style, text, id: 0, is_remove_brand: 0 }
